import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {DokumentAnnoteringId, DokumentVersjonModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {DomSanitizer} from "@angular/platform-browser";
import {DokumentInformasjonTjeneste} from "felles-ng2/tjenester/DokumentInformasjonTjeneste";
import {leggTilAnnoteringIdTilPdfjsUrl} from "felles-ng2/støttefunksjoner/pdfjs";

const debug = initDebugger('DokumentVisPdfIframeKomponent');

/**
 * Viser dokument i PDF-js pdf-viser i en iframe.
 * Støtter angivelse av annotering som skal gis fokus i pdf-viser.
 */
@Component({
    selector: 'dokument-vis-pdf-iframe',
    templateUrl: 'dokument-vis-pdf-iframe.html',
    styleUrl: 'dokument-vis-pdf-iframe.scss',
    imports: [],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DokumentVisPdfIframeKomponent {

    dokumentversjon = input.required<DokumentVersjonModell>();
    forespurtAnnoteringId = input<DokumentAnnoteringId>();

    url = computed(() => this.domSanitizer.bypassSecurityTrustResourceUrl(
      leggTilAnnoteringIdTilPdfjsUrl(
        this.dokumentInformasjon.dokumentinformasjon(this.dokumentversjon()).pdfjsDokumentViserUrl,
        this.forespurtAnnoteringId() ?? null)));

    constructor(private dokumentInformasjon: DokumentInformasjonTjeneste, private domSanitizer: DomSanitizer) {

    }
}
